module.exports = __webpack_public_path__ + "static/media/qrEnollmentCode.42c0567f.svg";